var map = {
	"./arrow-left-long.svg": 28652,
	"./bed.svg": 76099,
	"./cablecar.svg": 81625,
	"./cart.svg": 83855,
	"./check.svg": 78634,
	"./food.svg": 29753,
	"./infr-bike.svg": 78614,
	"./infr-climb.svg": 90135,
	"./infr-langl.svg": 86256,
	"./infr-wander.svg": 80400,
	"./search.svg": 21366,
	"./slopes.svg": 48575,
	"./snowflake.svg": 12119,
	"./video-camera.svg": 96887
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99476;